<template>
  <div>
    <div class="vx-row" v-if="canEdit" >
      <div class="vx-col md:w-1/3 w-full mb-base mb-6">
        <icon-card-line
          icon="UsersIcon"
          :statistic="active"
          :statisticTitle="$t('EstadoUsuario')"
        >
        </icon-card-line>
      </div>
    </div>

    <div class="vx-row" v-if="canEdit" >
      <div class="vx-col w-full">
        <edit-view-user :user="user" ></edit-view-user>
      </div>
    </div>
  </div>

</template>

<script>
  import EditViewUser from '../components/Users/EditViewUser';
  import EditNotificationsUser from '../components/Users/EditNotificationsUser';
  import ListZonesUser from '../components/Users/ListZonesUser';
  import ListRolesUser from '../components/Users/ListRolesUser';
  import IconCardLine from '../components/icon-cards/IconCardLine.vue'
  import {mapActions, mapGetters} from 'vuex';

  export default {
    components: {
      EditViewUser,
      EditNotificationsUser,
      ListZonesUser,
      ListRolesUser,
      IconCardLine,
    },
    data () {
      return {
      }
    },
    created () {
      this.getUser(this.$route.params.id);
    },
    computed: {
      ...mapGetters({
        user: 'getUser',
        userActiveCardData: 'getUserActiveCardData',
      }),
      canEdit () {
          return Object.keys(this.user).length;
      },
      active () {
          if (this.user.active === 1) {
              return 'ACTIVE';
          } else {
              return 'DESACTIVE';
          }
      }
    },
    methods: {
      ...mapActions({
        getUser: 'getUser',
      })
    }

  }

</script>

<style>

</style>
